export default {
    STANDARD_DATE: 'YYYY-MM-DD',
    BOOKING_TIME: 'h:mm a',
};